import React, { useState, useContext, useEffect, FormEvent } from "react";
import { Grid, Segment, Dropdown, Button, Input } from "semantic-ui-react";
import MinorList from "./MinorList";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import MinorStore from "../../../app/stores/minorStore";
import { Link, RouteComponentProps } from "react-router-dom";

const MinorDashboard: React.FC<RouteComponentProps> = ({
  match,
  location,
  history
}) =>  {
  const minorStore = useContext(MinorStore);
  const {loadProjects, searchProject } = minorStore;

  const [term, setTerm] = useState("");

  const handleInputChange=(event: FormEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    setTerm(value);
    searchProject(event.currentTarget.value);
  }

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    (query.get("status")) ?  loadProjects('Minor', query.get("status")!) : loadProjects('Minor', "");
  }, []);

  if (minorStore.loadingInitial)
    return <LoadingComponent content="Loading Projects" />;

  return (
    <Segment>
      <Grid>
        <Grid.Column width={4}>
         <Input  type="text" icon="search" placeholder="Search projects" onChange={handleInputChange} value={term}/>
        </Grid.Column>
        <Grid.Column width={4}>
  
        </Grid.Column>
        <Grid.Column width={5}></Grid.Column>
      <Grid.Column textAlign="center" width={3}>
        <Button
          as={Link}
          to={`/projectmanagement/minor-create`}
          color="linkedin"
          icon="add"
          content="Create New"
        />
      </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <MinorList />
        </Grid.Column>
        
      </Grid>
    </Segment>
  );
};

export default observer(MinorDashboard);
